import { isProd } from './config';

export const PUSHER_KEY = isProd ? 'e52a7699285578595565' : 'b85eacb4488fa64fc50e';
export const PUSHER_CLUSTER = 'us3';
